import React, { memo } from "react";
import Button from "react-bootstrap/Button";
import ActionPanel from "../../../../../components/action-panel-modal/action-panel";
import successIcon from "../../../../../assets/img/template-confirmation-icon.svg";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const TemplateTaskCreatePanelNew = ({
  show,
  onHide,
  isSubtask,
  AddAnotherTask,
}) => {
  let history = useHistory();

  const button1 = (
    <Button onClick={() => history.push("/admin?tab=templates")}>
      Go To Template List
    </Button>
  );
  const button2 = (
    <Button className="btn-outlined" onClick={AddAnotherTask}>
      Add Another Task
    </Button>
  );
  const mainText = (
    <div style={{ fontSize: "20px" }}>
      {`${
        isSubtask ? "Subtask" : "Task"
      } template has been created successfully.`}
    </div>
  );

  return (
    <ActionPanel
      show={show}
      onHide={onHide}
      header={`Create ${isSubtask ? "Subtask" : "Task"} Template Confirmation`}
      icon={successIcon}
      mainText={mainText}
      acceptButton={button1}
      rejectButton={button2}
    />
  );
};

TemplateTaskCreatePanelNew.propTypes = {
  isSubtask: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  AddAnotherTask: PropTypes.func.isRequired,
};
export default memo(TemplateTaskCreatePanelNew);
